import React from 'react';
import LazyLoad from 'react-lazyload';
import Link from '../../common/TrackedLink';
import config from '../../../config';

const LockTypes = () => {
	return (
		<section className="section section-lock-types" id="lock-types">
			<div className="section-content row">
				<div className="col">
					<h2 className="title">Locks you can trust</h2>
				</div>

				<div className="col sm-6">
					<div className="callout">
						<div className="image">
							<LazyLoad once={true} offset={200}>
								<img
									src={require('../../../resources/img/callouts/privacy-lock.png')}
									alt="Privacy Key Lock"
								/>
							</LazyLoad>
						</div>
						<h3>Privacy Key Lock</h3>
						<p>Our most standard option and the simplest way to secure your valuables. Typically accompanied by a spare for convenience.</p>
					</div>
				</div>

				<div className="col sm-6">
					<div className="callout">
						<div className="image">
							<LazyLoad once={true} offset={200}>
								<img
									src={require('../../../resources/img/callouts/tubular_key.png')}
									alt="Tubular Key"
								/>
							</LazyLoad>
						</div>
						<h3>Tubular Key</h3>
						<p>Basic privacy protection with improved pick resistance. Accompanied by a spare for convenience.</p>
					</div>
				</div>

				<div className="col sm-6">
					<div className="callout">
						<div className="image">
							<LazyLoad once={true} offset={200}>
								<img
									src={require('../../../resources/img/callouts/3-number-lock.png')}
									alt="3-Number Lock"
								/>
							</LazyLoad>
						</div>
						<h3>3 Number Lock</h3>
						<p>A 3 number, programmable combination. No batteries required.</p>
					</div>
				</div>

				<div className="col sm-6">
					<div className="callout">
						<div className="image">
							<LazyLoad once={true} offset={200}>
								<img
									src={require('../../../resources/img/callouts/Biometric-Lock_Dual-Key.png')}
									alt="Biometric Lock with Dual Key"
								/>
							</LazyLoad>
						</div>
						<h3>Biometric Lock</h3>
						<p>
							Our most advanced locking system allows you to access your safe with the swipe of a finger. Comes with a dual key for added security.
						</p>
					</div>
				</div>

				<div className="col sm-6">
					<div className="callout">
						<div className="image">
							<LazyLoad once={true} offset={200}>
								<img
									src={`${config.contentUrl}/sentrysafe/features/FP_ComboDial.png`}
									alt="Combination Lock"
									width={100}
								/>
							</LazyLoad>
						</div>
						<h3>Combination Lock</h3>
						<p>Our 3 or 4 number factory-set combination locks are one of the most reliable forms of securing your valuables.</p>
					</div>
				</div>

				{/* <div className="col sm-6">
					<div className="callout">
						<div className="image">
							<LazyLoad once={true} offset={200}>
								<img
									src={require('../../../resources/img/callouts/Combination-Lock-w-Dual-Key.png')}
									alt="Combination Lock with Dual Key"
								/>
							</LazyLoad>
						</div>
						<h3>Combination Lock with Dual Key</h3>
						<p>Includes a dual key in addition to the 3 or 4 number factory-set combination to provide increased security.</p>
					</div>
				</div> */}

				<div className="col sm-6">
					<div className="callout">
						<div className="image">
							<LazyLoad once={true} offset={200}>
								<img
									src={`${config.contentUrl}/sentrysafe/features/FP_DigitalKeypad.png`}
									alt="Digital Lock"
									width={100}
								/>
							</LazyLoad>
						</div>
						<h3>Digital Lock</h3>
						<p>This battery-powered digital locking system uses a programmable 1-8 digit code. Offers multiple user options.</p>
					</div>
				</div>

				<div className="col sm-6">
					<div className="callout">
						<div className="image">
							<LazyLoad once={true} offset={200}>
								<img
									src={`${config.contentUrl}/sentrysafe/features/FP_IlluminatedKeypad.png`}
									alt="Digital Lock with Backlit Keypad"
									width={100}
								/>
							</LazyLoad>
						</div>
						<h3>Digital Lock with Backlit Keypad</h3>
						<p>This battery-powered backlit digital locking system uses a programmable 1-8 digit code.</p>
					</div>
				</div>

				{/* <div className="col sm-6">
					<div className="callout">
						<div className="image">
							<LazyLoad once={true} offset={200}>
								<img
									src={require('../../../resources/img/callouts/Digital-Lock-w-Backlit-Keypad_and_Dual-Key.png')}
									alt="Digital Lock with Backlit Keypad and Dual Key"
								/>
							</LazyLoad>
						</div>
						<h3>Digital Lock with Backlit Keypad and Dual Key</h3>
						<p>This battery-powered backlit digital locking system uses a programmable 1-8 digit code. Comes with a dual key for added security; Offers multiple user options.</p>
					</div>
				</div> */}

				<div className="col sm-6">
					<div className="callout">
						<div className="image">
							<LazyLoad once={true} offset={200}>
								<img
									src={require('../../../resources/img/callouts/touchscreen-lock.png')}
									alt="Touchscreen Lock"
								/>
							</LazyLoad>
						</div>
						<h3>Touchscreen Lock</h3>
						<p>Touchscreen digital keypad is designed to emit a loud alarm when your safe is picked up or moved, the door is pried open, or five wrong code attempts are entered.</p>
					</div>
				</div>

				{/* <div className="col sm-6 clear">
					<div className="callout">
						<div className="image">
							<LazyLoad once={true} offset={200}>
								<img
									src={require('../../../resources/img/callouts/touchscreen-lock-dual-key.png')}
									alt="Touchscreen Lock with Dual Key"
								/>
							</LazyLoad>
						</div>
						<h3>Touchscreen Lock with Dual Key</h3>
						<p>Touchscreen digital keypad is designed to emit a loud alarm when your safe is picked up or moved, the door is pried open, or five wrong code attempts are entered. Comes with a dual key for added security.</p>
					</div>
				</div> */}

				<div className="col sm-6" id="dual-key">
					<div className="callout">
						<div className="image">
							<LazyLoad once={true} offset={200}>
								<img
									src={require('../../../resources/img/callouts/dual-key.png')}
									alt="Dual Key"
								/>
							</LazyLoad>
						</div>
						<h3>Dual Key</h3>
						<p>A dual key gives safe owners the ability to disable the primary lock, even if other people know the combination or access code. It is not a backup key.</p>
					</div>
				</div>

				<div className="col sm-6 ">
					<div className="callout">
						<div className="image">
							<LazyLoad once={true} offset={200}>
								<img
									src={require('../../../resources/img/callouts/card-swipe.png')}
									alt="Card Swipe Reader"
								/>
							</LazyLoad>
						</div>
						<h3>Card Swipe Reader</h3>
						<p>This reprogrammable lock includes a digital keypad with card swipe access, allowing you to enter a code or use any card with a magnetic strip to open and close your safe. No personal information or credit card numbers are used in this operation.</p>
					</div>
				</div>

				<div className="col sm-6 clear">
					<div className="callout">
						<div className="image">
							<LazyLoad once={true} offset={200}>
								<img
									src={`${config.contentUrl}/sentrysafe/features/FP_OverrideKey.png`}
									alt="Override Key"
									width={100}
								/>
							</LazyLoad>
						</div>
						<h3>Override Key</h3>
						<p>For convenient backup access or emergency situations.</p>
					</div>
				</div>


			</div>
		</section>
	);
};

export default LockTypes;



// WEBPACK FOOTER //
// ./src/pages/learn/buyingGuide/LockTypes.js